export default __webpack_public_path__ + "static/about-illustration-95fd061d7e2e863f2f8b663c0d1383a2.svg";